import React from 'react';
import styled from 'react-emotion';
import ProductLink from '@jetshop/ui/ProductLink';
import Image from '@jetshop/ui/Image';
import { transparentDataImg } from '@jetshop/ui/Image/Image';
import Badges from '@jetshop/ui/ProductList/Badges';
import { InformationPopup } from '../ProductPackage/InformationPopup';
import { useFauxPricing } from '../ProductPackage/useFauxPricing';
import { Price } from '../../Price';
import { VariantSelector } from '../VariantSelector';
import { useProductVariants } from '@jetshop/core/hooks/useProductVariants';
import { DrawerTrigger } from '@jetshop/ui/Modal/Drawer/DrawerTrigger';
import Button from '../../ui/Button';
import t from '@jetshop/intl';
import { Form } from 'formik';
import AddToCartForm from '../AddToCart/AddToCartForm';
import { theme } from '../../Theme';

const UpsellWrapper = styled('div')`
  margin-top: 20px;

  /* h3 {
    margin-bottom: 10px;
    text-transform: none;
  } */
  .product-card {
    display: flex;
    width: 100%;
    margin-bottom: 20px;
  }
`;

const UpsellProductWrapper = styled('div')`
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  padding: 10px;

  .variant-selector {
    font-size: 14px;
  }

  h3 {
    font-weight: 400;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* text-overflow: ellipsis; */
    /* white-space: nowrap; */
    /* overflow: hidden; */
    font-weight: normal;
    margin-bottom: 0;
    text-transform: uppercase;
    /* ${theme.below
      .md} {
      font-size: 12px;
      white-space: initial;
      position: relative;

      //max-height: 33px;
      overflow: hidden;
      display: block;
      width: 100%;
    } */
  }

  .product-link {
    /* max-width: 50%; */
    width: 100%;
  }

  .product-image-wrapper {
    border: none;
    /* padding: 5px; */
    background: white;
    width: 100%;
    picture {
      mix-blend-mode: multiply;
    }

    .no-product-image {
      > div {
        background: white !important;
        text-align: center;
      }
    }
  }

  .product-card-detail {
    background-color: #fff;
    min-width: 45%;
    /* margin-left: 20px; */

    /* padding: 0.75em 10px; */
    /* padding: 10px !important; */
    line-height: 1.35;
    text-align: start;
    width: 100%;
    max-width: 45%;

    h4 {
      font-weight: normal;
      font-size: 1em;
      color: ${theme.colors.black};
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;

const StyledPrice = styled(Price)`
  font-weight: bold;
  font-size: 12px !important;
  & > div {
    display: flex;
    justify-content: start;
    margin: 0;
  }
  .price {
    font-weight: bold;
    font-size: 16px !important;
  }
  .new-price {
    font-size: 16px !important;
    color: #ff0000;
    margin-right: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .old-price {
    font-size: 16px !important;
    color: #878787;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

const StyledForm = styled(Form)`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 10px;
  ${({ theme }) => theme.below.md} {
    align-items: center;
    button {
      font-size: 14px;
    }
  }

  button {
    padding: 0;
    height: 36px;
    line-height: 36px;
  }
`;

export const UpsellProduct = ({
  product,
  imageSizes = [1 / 4, 1 / 3, 1 / 2, 1 / 2],
  information,
  children,
  ...linkProps
}) => {
  const hasImages = product?.images && product?.images?.length > 0;
  const { fauxPrice } = useFauxPricing(product);

  const variantHandler = useProductVariants(
    product?.articleNumber ? product : 'undefined'
  );

  const {
    selectedVariant: selectedVariation,
    validation: variantValidation,
    getMissingOptions,
  } = variantHandler;

  function calculateBuyButtonText(product, variantValidation) {
    if (product.stockStatus.buyable && variantValidation === 'valid') {
      return t('Add to cart');
    }
    if (variantValidation === 'incomplete' && product.stockStatus.buyable) {
      return t('Välj alternativ');
    }
    return t('Ej i lager');
  }

  console.log('product', product);
  return (
    <UpsellProductWrapper>
      <AddToCartForm
        product={product}
        variant={selectedVariation}
        getMissingOptions={getMissingOptions}
      >
        <ProductLink className="product-link" product={product} {...linkProps}>
          <div className="product-image-wrapper">
            {hasImages ? (
              <Image
                className="product-image"
                sizes={imageSizes}
                aspect={'4:3'}
                alt={product.images[0].alt}
                src={product.images[0].url}
              >
                <Badges badges={product.badges} />
              </Image>
            ) : (
              <Image
                className="no-product-image product-image"
                sizes={imageSizes}
                aspect={'4:3'}
                src={transparentDataImg}
              />
            )}
          </div>
        </ProductLink>
        <section className="product-card-detail">
          {information && <InformationPopup product={product} />}
          <header>
            <h3>{product.name}</h3>
          </header>
          {/* <div className="price-wrapper"> */}
          <StyledPrice
            price={product.price}
            previousPrice={product.previousPrice}
          />
          {/* </div> */}
          <div className="variant-selector">
            <VariantSelector
              product={product}
              variantHandler={variantHandler}
              preselected={false}
              dropDownSelect={true}
            />
          </div>
          <StyledForm>
            <DrawerTrigger id="cart-drawer">
              {(drawer) => (
                <Button
                  data-testid="add-to-cart"
                  type="submit"
                  disabled={
                    !(
                      product.stockStatus.buyable &&
                      variantValidation === 'valid'
                    )
                  }
                  onClick={
                    drawer.isOpen ? drawer.hideTarget : drawer.showTarget
                  }
                >
                  {product?.stockStatus?.text?.includes('Finns i butiken')
                    ? 'Säljs endast i butik'
                    : calculateBuyButtonText(product, variantValidation)}
                </Button>
              )}
            </DrawerTrigger>
          </StyledForm>

          {children}
        </section>
      </AddToCartForm>
    </UpsellProductWrapper>
  );
};

export const Upsell = ({ product }) => {
  return (
    <UpsellWrapper>
      <h3 style={{ marginBottom: '10px' }}>Rekommenderade tillbehör</h3>
      {product?.upsell?.items?.map((item, index) => {
        return (
          <>
            <UpsellProduct product={item?.product} information={true} />
          </>
        );
      })}
    </UpsellWrapper>
  );
};
